import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil'
import { Paths } from 'src/navigation'
import { usePutDossier } from 'src/networking/terminals'
import {
  atomDossier,
  atomFormikPolicy,
  atomSelectedProduct,
  selectorDossierHasProducts,
} from 'src/storage'

import { useProgress } from '../policy-configuration/sections'
import { getProductPathFromCode, ProductsCodeMap } from './products_mapping.utils'

export const useProductsLandingWrapper = ({ codProd }: { codProd: ProductsCodeMap }) => {
  const location = useLocation()

  const navigate = useNavigate()
  const [dossier, setDossier] = useRecoilState(atomDossier)
  const hasProducts = useRecoilValue(selectorDossierHasProducts)
  const [selectedProduct, setSelectedProduct] = useRecoilState(atomSelectedProduct)

  const resetFormikPolicy = useResetRecoilState(atomFormikPolicy)
  const { setCurrentStep } = useProgress()

  const { crossGate: putDossier } = usePutDossier()

  useEffect(() => {
    if (!dossier || !dossier.prodotti || dossier.prodotti.length === 0) return

    const now = new Date()

    const mostRecentProduct = dossier.prodotti?.reduce((a, b) => {
      const dayDifferenceA = Math.abs(new Date(a.stagioni[0].dataInizio).getTime() - now.getTime())
      const dayDifferenceB = Math.abs(new Date(b.stagioni[0].dataInizio).getTime() - now.getTime())

      return dayDifferenceB < dayDifferenceA ? b : a
    })

    setSelectedProduct(mostRecentProduct)
  }, [dossier, dossier?.prodotti])

  useEffect(() => {
    resetFormikPolicy()
    setCurrentStep(1)
  }, [])

  useEffect(() => {
    if (!dossier || !hasProducts) return

    const actSelectedCod = dossier.codProd
    if (actSelectedCod === codProd) return

    const path = getProductPathFromCode(actSelectedCod)
    navigate(path)
  }, [dossier])

  const navigateToLandingString = Paths.Landing + location.search

  return { dossier, selectedProduct, hasProducts, navigateToLandingString }
}
